/**
 * Concatenates class names, filtering out falsy values.
 *
 * @example classNames('foo', isBar ? 'bar' : null, 'baz') => 'foo baz' when isBar == false
 * @example classNames(['foo', 'bar']) => 'foo bar'
 *
 * @param {...string} args
 * @returns {string}
 */
export const classNames = (...args) => {
    if (args.length && args[0] instanceof Array) {
        args = args[0];
    }
    return args.filter(Boolean).join(' ');
};
